import { useEffect, useRef, useState } from "react";
import { useNavigate } from "react-router";

export const useNavigationGuard = (shouldBlock: boolean) => {
  const navigate = useNavigate();
  const [nextLocation, setNextLocation] = useState<string | null>(null);
  const [showPrompt, setShowPrompt] = useState(false);
  const shouldBlockRef = useRef(shouldBlock);

  useEffect(() => {
    shouldBlockRef.current = shouldBlock;

    const handleBeforeUnload = (e: BeforeUnloadEvent) => {
      if (shouldBlockRef.current) {
        e.preventDefault();
        e.returnValue = ""; //pour chrome
      }
    };

    window.addEventListener("beforeunload", handleBeforeUnload);
    return () => window.removeEventListener("beforeunload", handleBeforeUnload);
  }, [shouldBlock]);

  const handleNavigate = (
    path: string,
    dap?: string | null,
    name?: string | null,
  ) => {
    if (shouldBlock) {
      setNextLocation(path);
      setShowPrompt(true);
    } else {
      navigate(path, { state: dap !== undefined ? { dap, name } : undefined });
    }
  };

  const confirmNavigation = () => {
    setShowPrompt(false);
    if (nextLocation) {
      navigate(nextLocation);
      shouldBlockRef.current = false; // Reset the block state after navigation
    }
  };

  const cancelNavigation = () => {
    setShowPrompt(false);
    setNextLocation(null);
  };

  return { handleNavigate, showPrompt, confirmNavigation, cancelNavigation };
};
